import { useScrollToTop } from '../../hooks/useScrollToTop';

interface ScrollToTopOnNavigationProps {
  smooth?: boolean;
  delay?: number;
}

/**
 * Component that automatically scrolls to the top of the page on route changes.
 * This component doesn't render anything visible.
 * 
 * @param {Object} props - Component properties
 * @param {boolean} props.smooth - Whether to use smooth scrolling (default: false)
 * @param {number} props.delay - Optional delay in ms before scrolling (default: 0)
 */
export const ScrollToTopOnNavigation: React.FC<ScrollToTopOnNavigationProps> = ({
  smooth = false,
  delay = 0
}) => {
  // Use the custom hook to handle scroll behavior
  useScrollToTop({ smooth, delay });
  
  // This component doesn't render anything
  return null;
}; 